import { useSelector } from 'react-redux';
import { getShopElement } from '../../selectors';
import { IStore } from 'store/interface';
import { InventoryItem } from 'games/CaseGame/interfaces';

export const useShopElement = (idx: number) => ({
  item: useSelector<IStore, InventoryItem>(getShopElement(idx)),
});
